$(document).ready(function(){
    announcement();
    footerForm();
    popup();
    contactForm();
    bronzallureForm();
    gTag();
    searchCountry();
    accordion();
    swiperProduct();
    carosel();
    cartNum();
    quickView();
});

function announcement(){
    if($('.AnnouncementBar__Content').length > 1){
        setInterval(function(){
            var lastActive = $('.AnnouncementBar__Content.active');
            $('.AnnouncementBar__Content').removeClass("active");
            if($(lastActive).next().length){
                $(lastActive).next().addClass('active');
            }
            else{
                $('.AnnouncementBar__Content').first().addClass('active');
            }
        }, $('.AnnouncementBar__Wrapper').attr('data-announcement-seconds')*1000);
    }
    if($('[data-timer]').length){

        showTimer();

        setInterval(showTimer, 1000);
    }

    function showTimer(){
        var stamp = parseInt($('[data-timer]').attr('data-timer'))*1000;
        var diff = parseInt((stamp - Date.now()) / 1000);
        if(diff >= 0){
            const MINUTE = 60
            const HOUR = 60 * 60
            const DAY = 60 * 60 * 24
    
            var stacks = [];
            if(diff < 60){
                stacks.push('<div class="timer-obj"><h3>'+diff+'</h3><small>'+translationsTimer.seconds+'</small></div>');
            } else if(diff < HOUR){
                var sec = diff%MINUTE;
                var min = (diff - sec) / MINUTE;
                stacks.push('<div class="timer-obj"><h3>'+min+'</h3><small>'+translationsTimer.minutes+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+sec+'</h3><small>'+translationsTimer.seconds+'</small></div>');
            } else if(diff < DAY){
                var sec = diff%MINUTE;
                var min = (diff%HOUR-sec)/ MINUTE;
                var hours = (diff-(diff%HOUR))/HOUR;
                stacks.push('<div class="timer-obj"><h3>'+hours+'</h3><small>'+translationsTimer.hours+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+min+'</h3><small>'+translationsTimer.minutes+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+sec+'</h3><small>'+translationsTimer.seconds+'</small></div>');
            } else {
                var sec = diff%MINUTE;
                var min = (diff%HOUR-sec)/ MINUTE;
                var hours = (diff%DAY-(diff%HOUR))/ HOUR;
                var days = (diff-(diff%DAY))/DAY;
                stacks.push('<div class="timer-obj"><h3>'+days+'</h3><small>'+translationsTimer.days+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+hours+'</h3><small>'+translationsTimer.hours+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+min+'</h3><small>'+translationsTimer.minutes+'</small></div>');
                stacks.push('<div class="timer-obj"><h3>'+sec+'</h3><small>'+translationsTimer.seconds+'</small></div>');
            }
    
            $('[data-timer-content]').html(stacks.join(' '));
        }
    }
}

function carosel(){
    $('.Product__SlideshowNavImage').on('click', function(){
        $('.Product__SlideshowNavImage').removeClass('is-selected');
        $(this).addClass('is-selected');
    });
}


function swiperProduct(){
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: "auto",
        cssMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        mousewheel: true,
        keyboard: true,
      });
}

function footerForm(){
    if($('#footer-form').length){
        if(getCookie('subscribed') !== undefined){
            $('#footer-form-thankyou').removeClass('hide');
            $('#footer-form-section').addClass('hide');
        } else {
            var msg = $('#footer-form').attr('data-form-success');
            new validateForm($('#footer-form'), {
                successMsg: msg,
                onSuccessAlertClose: function(data){
                    setCookie("subscribed", true, 365);
                    gTagNewsletter('footer');
                    location.reload();
                }
            }).init();
        }
    }
}

function bronzallureForm(){
    if($('#_form_111_').length){
        if(getCookie('subscribed') !== undefined){
            $('#bronzallure-thankyou').removeClass('hide');
            $('#bronzallure-section').addClass('hide');
        } else {
            new validateForm($('#_form_111_'), {
                successMsg: $('#_form_111_').attr('data-form-success'),
                onSuccessAlertClose: function(data){
                    setCookie("subscribed", true, 365);
                    gTagNewsletter('club');
                    location.reload();
                }
            }).init();
        }
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function deleteCookie(name) {
    var date = new Date();
    date.setTime(0);
    document.cookie = name + "=" + date.toUTCString() + "; path=/";
}

function popup(){
    if($('#popup-form').length)
        createPopup('#popup-form');

    function createPopup(el){
        var percentage = parseInt($(el).attr('data-popup-trigger-scroll'));
        var closed = getCookie('popup-closed');
        var used = getCookie('subscribed');
        var success = $(el).attr('data-popup-success');
        var expireDays = $(el).attr('data-popup-timer');
        var code = $(el).find('[data-copy]').attr('data-copy');
        
        if(closed == undefined && used == undefined && success == undefined){
            triggers();
        }
        $('[data-popup-close]').on('click', function(e){
            e.preventDefault();
            closePopup();
        });
        $('[data-copy]').on('click', function(){
            copyText(this);
        });

        function triggers(){
            if($(el).attr('data-popup-trigger') == 'now'){
                $('body').addClass('modal-open');
            }
            else if($(el).attr('data-popup-trigger') == 'delay'){
                var seconds = parseInt($(el).attr('data-popup-trigger-delay')) * 1000;
                setTimeout(function(){
                    $('body').addClass('modal-open');
                }, seconds);
            }
            else if($(el).attr('data-popup-trigger') == 'scroll'){
                window.addEventListener('scroll', showOnScroll);
            }
            else if($(el).attr('data-popup-trigger') == 'inactivity'){
                onInactive(20*1000, function(){
                    $('body').addClass('modal-open');
                });
            }
            else if($(el).attr('data-popup-trigger') == 'leave'){
                window.addEventListener('beforeunload', function(e) {
                    $('body').addClass('modal-open');
                    e.preventDefault();
                    e.returnValue = ''; 
                });
            }
            new validateForm($('#popup-form'), {
                onSuccess: function(data){
                    setCookie("subscribed", true, 365);
                    $(el).find('.popup-form').addClass('popup-success');
                    gTagNewsletter('popup');
                }
            }).init();
        }
        function showOnScroll(){
            if($(window).scrollTop() + $(window).height() >= $(document).height()/100*percentage) {
                $('body').addClass('modal-open');
                window.removeEventListener('scroll', showOnScroll);
            }
        }
        function onInactive(ms, cb){
            var wait = setTimeout(cb, ms); 
            document.onmousemove = document.mousedown = document.mouseup = document.onkeydown = document.onkeyup = document.focus = function(){
                clearTimeout(wait);
                wait = setTimeout(cb, ms);
            };
        }
        function closePopup(){
            $('body').removeClass('modal-open');
            if(expireDays > 0 && used == undefined){
                setCookie("popup-closed", true, expireDays);
            }
        }
        function copyText(i){
            var feedbackEl = $(el).parents('form').find('[data-copy-feedback]');
            var feedback = $(feedbackEl).attr('data-copy-feedback');
            var text = $(feedbackEl).text();
            if (!navigator.clipboard){
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val(code).select();
                document.execCommand("copy");
                $temp.remove();
            } else{
                navigator.clipboard.writeText(code);
            } 
            $(feedbackEl).text(feedback);
            setTimeout(function(){
                $(feedbackEl).text(text);
            }, 3000);
        }
        
    }
}

function contactForm(){
    if($('#_form_49_').length){
        new validateForm($('#_form_49_'), {
            successMsg: $('#_form_49_').attr('data-form-success'),
            onSuccessAlertClose: function(data){
                gTagContact('contact');
                location.reload();
            }
        }).init();
    }
}

function arrayCompare(a1, a2) {
    if (a1.length != a2.length) return false;
    var length = a2.length;
    for (var i = 0; i < length; i++) {
        if (a1[i] !== a2[i]) return false;
    }
    return true;
}

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(typeof haystack[i] == 'object') {
            if(arrayCompare(haystack[i], needle)) return true;
        } else {
            if(haystack[i] == needle) return true;
        }
    }
    return false;
}

var shown = [];
var prods = [];
function gTag(){
    var observer = new IntersectionObserver(function(entries){
        $(entries).each(function(){
            if(this.isIntersecting){
                gTagShow(this.target);
            }
        });
    }, {threshold: [0.9]});

    $('[data-gtag-promo]').each(function(){
       observer.observe(this);
    });

    $('[data-gtag-click]').on('click', function(e, options) {
        gTagClick(this, e);
    });

    $('[data-gtag-list]').each(function(){
        gTagList(this);
    });

    $('[data-gtag-product-item] *').on('click', function(e) {
        e.stopPropagation();
        gTagProductClick(this);
    });

    $('[data-gtag-logout]').on('click', function(e) {
        gTagLogout(this);
    });

    $(window).on('product:added', function(e){
        gTagAdd(e.originalEvent.detail);
    });

    $(document).on('product:removed', function(e){
        gTagRemove(e.originalEvent.detail.button);
    });

    $(document).on('estimator:success', function(e){
        gTagEstimator(e.originalEvent.detail);
    });

    if($('[develic-map]').length){
        var int_dev = setInterval(function(){
            if($('.develic-item').length){
                $('.develic-item').on('click', function(){
                    gTagStore(this);
                });
                clearInterval(int_dev);
            }
        }, 100);
    }

    var formAccount = $('#customer_login');
    if($(formAccount).length == 0)
        formAccount = $('#create_customer');
    if($(formAccount).length){
        var int_to = setInterval(function(){
            var num = $(formAccount).find('input[name="return_to"]').length;
            if(num > 1){
                $(formAccount).find('input[name="return_to"]').last().remove();
                clearInterval(int_to);
            }
        }, 100);
        var int_url = setInterval(function(){
            var num = $(formAccount).find('input[name="return_url"]').length;
            if(num > 1){
                $(formAccount).find('input[name="return_url"]').last().remove();
                clearInterval(int_url);
            }
        }, 100);
    }
}

function gTagProductClick(el){
    var item = $(el).parents('[data-gtag-product-item]');
    var pel = $(item).find('[data-gtag-product-info]');
    if($(pel).length){
        var json = JSON.parse($(pel).first().html());
        var name = json.product.type;
        var list = $(el).parents('[data-gtag-list]');
        var index = $(item).index();
        if($(list).length){
            name = $(list).attr('data-gtag-list');
        }
        var product = {
            "id": json.product.id,
            "price": json.variant.price/100,
            "name": json.product.title,
            "category": json.product.type,
            "brand": json.product.vendor,
            "posiJon": index,
            'variant': json.variant.id,
            "list": name,
            "available": json.variant.available ? "yes" : "no",
            "quanJty": 1
        };
        window.dataLayer.push({
            event: 'productClick',
            list: name, 
            products: [product]
        });
    }
}

function gTagList(el){
    var name = $(el).attr('data-gtag-list');
    var sort = $(el).attr('data-gtag-list-sort');
    var search = $(el).attr('data-gtag-list-search');
    var fel = $(el).find('[data-gtag-list-filters]');
    if($(fel).length){
        var filters = JSON.parse($(fel).html());
    }
    var pel = $(el).find('[data-gtag-product-info]');
    var products = [];
    $(pel).each(function(){
        var json = JSON.parse($(this).html());
        products[products.length] = {
            "id": json.product.id,
            "price": json.variant.price/100,
            "name": json.product.title,
            "category": json.product.type,
            "brand": json.product.vendor,
            "posiJon": products.length,
            'variant': json.variant.id,
            "list": name,
            "available": json.variant.available ? "yes" : "no",
            "quanJty": 1
        };
    });
    window.dataLayer.push({ 
        event: 'productImpressions',
        list: name, 
        filters: filters != undefined && filters.length > 0 ? filters : undefined,
        searchKeyword: search,
        searchResultNumber: $(pel).length,
        sortValue: sort,
        products: products
    });
}

function gTagClick(el, e){
    var promo = $(el).parents('[data-gtag-promo]');
    if($(promo).length){
        var title = $(promo).find('[data-gtag-title]').text();
        var creative = $(promo).find('[data-gtag-creative]').attr('href');
        if(!creative)
            creative = $(promo).attr('href');
        var index = $(promo).parents('.shopify-section').index();
        var page = $(promo).attr('data-gtag-page') == 'index' ? 'homepage' : $(el).attr('data-gtag-page');
        if($(promo).find('[data-gtag-title]').length){
            window.dataLayer.push({
                event: 'promoClick',
                promotions: [{
                    id: page,
                    name: title, 
                    creative: creative,
                    position: index 
                }]
            });
        }
    }
}

function gTagShow(el){
    var id = $(el).attr('data-gtag-promo');
    if(($(el).find('[data-gtag-title]').length) && !inArray(id, shown)){
        var show = true;
        if($(el).is('.Slideshow__Slide')){
            show = $(el).is('.is-selected');
        }
        if(show){
            var title = $(el).find('[data-gtag-title]').text();
            var creative = $(el).find('[data-gtag-creative]').attr('href');
            if(!creative)
                creative = $(el).attr('href');
            var index = $(el).parents('.shopify-section').index();
            var page = $(el).attr('data-gtag-page') == 'index' ? 'homepage' : $(el).attr('data-gtag-page');
            window.dataLayer.push({
                event: "promoView",
                promotions: [{
                    id: page,
                    name: title, 
                    creative: creative,
                    position: index 
                }]
            });
            shown[shown.length] = id;
        }
    }
}

function gTagAdd(el){
    var product = {
        "id": el.variant.id,
        "price": el.variant.price/100,
        "name": el.product.title,
        "category": el.product.type,
        "brand": el.product.vendor,
        "available": el.variant.available ? "yes" : "no",
        "quanJty": el.quantity,
        "size": el.variant.option1,
        "stone": el.variant.option2,
        "color": el.variant.option3
    };
    window.dataLayer.push({
        event: 'addToCart',
        products: [product]
    });
}

function gTagRemove(btn){
    var item = $(btn).parents('[data-gtag-cart-item]');
    if($(item).length){
        var info = $(item).find('[data-gtag-product-info]');
        var json = JSON.parse($(info).html());
        var product = {
            "id": json.variant.id,
            "price": json.variant.price/100,
            "name": json.product.title,
            "category": json.product.type,
            "brand": json.product.vendor,
            "available": json.variant.available ? "yes" : "no",
            "quanJty": json.quantity,
            "size": json.variant.option1,
            "stone": json.variant.option2,
            "color": json.variant.option3
        };
        window.dataLayer.push({
            event: 'removeFromCart',
            products: [product]
        });
    }
}

function gTagCart(cart){
    window.dataLayer.push({
      event: "cartview",
      products: cartProducts
    });
}

function gTagLogout(btn){
    var id = $(btn).attr('data-gtag-logout');
    window.dataLayer.push({
        event: 'logoutSuccess',
        userId: id
    });
}

function gTagNewsletter(type){
    window.dataLayer.push({
        event: 'newsletterSuccess',
        newsletterType: type
    });
}

function gTagStore(btn){
    var text = $(btn).find('.develic-heading').text();
    window.dataLayer.push({
        event: 'storeLocator',
        storeName: text
    });
}

function gTagEstimator(data){
    window.dataLayer.push({
        event: 'shippingTimeCalculation',
        shippingCalculationCountry: data.country,
        shippingCalculationCity: data.zip
    });
}

function gTagContact(type){
    window.dataLayer.push({
        event: 'submitForm',
        name: type
    });
}

function searchCountry(){
    if($('#search-country').length){
        $('#search-country').on('keyup', function(){
            $('#modal-countries .col').addClass('d-none');
            var val = $(this).val().toLowerCase();
            $('#modal-countries .col').each(function(){
                var text = $(this).text().toLowerCase();
                if(text.includes(val)){
                    $(this).removeClass('d-none');
                }
            });
        });
    }
}

function accordion(){
    $('#accordion').find('.accordion-toggle').click(function(){
        var isActive = $(this).hasClass("active_acc");
                $('.accordion-toggle').removeClass('active_acc')
        if (!isActive) {
            $(this).toggleClass('active_acc');
        }
            
        $(this).next().slideToggle('fast');     
        $(".accordion-content").not($(this).next()).slideUp('fast');
    
    });
}

function cartNum(){
    $(window).on('product:added', function(){
        $.ajax({
          type: 'POST',
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            $('.Header__CartNum').addClass('d-block').text(data.item_count);
          }
        });
    });
}

function quickView(){
    $('[data-quickview]').on('click',function(e){
        $('.quick_drawer_wrapper').addClass('d-none');
        var id_drawer = $(this).attr('data-quickview');
        $(id_drawer).removeClass('d-none');
    });
    $('.close_drawer').on('click',function(){
        $('.quick_drawer_wrapper').addClass('d-none');
    });

    $('[data-quickview-input]').on('change', function(){
        var value = $(this).attr('data-quickview-input');
        $(this).parents('.option-wrapper').find('[data-quickview-option-name]').text(value);
    });

    $('[data-quickview-option]').on('click', function(e){
        e.preventDefault();
        var value = $(this).attr('data-quickview-option');
        var parent = $(this).parents('form');

        $(this).parents('.option-wrapper').find('[data-quickview-option-name]').text(value);


        $(parent).find('[data-quickview-option]').removeClass('active');
        $(this).addClass('active');
        $(parent).find('[data-quickview-parent]').removeClass('parent');
        $(parent).find('[data-quickview-parent="'+value+'"]').addClass('parent');
        var v = $(parent).find('[data-quickview-parent="'+value+'"]').first().val();
        $(parent).find('[data-quickview-select]').val(v);
    });

    $('[data-quickview-submit]').on('click', function(){
        var form = $(this).parents('form').get(0);
        var params = new FormData(form);
        var btn = this;
        var initialText = $(btn).text();
        var addedText = $(btn).attr('data-quickview-submit');
        $(btn).text('...');
        $.ajax({
          type: 'POST',
          url: $(form).attr('action'),
          data: params,
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            $(btn).text(addedText);
            location.reload();
          },
          error: function (err) {
            console.log(err);
          }
        });
    });
}